// Utility function for default images based on gender

export const getDefaultImage = (gender) => {
  if (gender?.toLowerCase() === "male") {
    return "/default-male.jpg";
  } else if (gender?.toLowerCase() === "female") {
    return "/default-female.jpg";
  }
  return "/default-male.jpg";
};
